import { Component, EventEmitter, Output } from '@angular/core';
import { ChiliPiperService } from '@self-serve/services/calendar/chili-piper.service';
import { AnalyticService, AuthService } from '@app/services';
import { AnalyticEvents } from '@app/enums';
import { PlatformModule } from '@app/platform.module';
import { TranslateModule } from '@ngx-translate/core';
import { MeetingSchedulerService } from '@self-serve/interface/calendar.abstract';
import { FakeCalendarService } from '@self-serve/services';
import { environment } from '@env/environment';
import * as Sentry from '@sentry/browser';

/**
 * Use FakeCalendarService for dev & testing. Use ChiliPiperService for everything else.
 */
function calendarFactory(): MeetingSchedulerService {
    if (['local', 'e2e', 'qa', 'sec'].includes(environment.name ?? '')) {
        return new FakeCalendarService();
    }
    return new ChiliPiperService();
}

@Component({
    standalone: true,
    selector: 'app-self-serve-calendar-button',
    imports: [PlatformModule, TranslateModule],
    providers: [{ provide: MeetingSchedulerService, useFactory: calendarFactory }],
    template: `
        <ui-button type="primary" (click)="bookMeeting()"
            >{{ 'self-serve.bookACall.bookACallSetup' | translate }}
        </ui-button>
    `,
})
export class CalendarButtonComponent {
    @Output() meetingDate = new EventEmitter<Date>();

    constructor(
        public analyticService: AnalyticService,
        private authService: AuthService,
        private meetingSchedulerService: MeetingSchedulerService
    ) {}

    async bookMeeting(): Promise<void> {
        try {
            const meetingDate = await this.meetingSchedulerService.bookMeeting(this.authService.employee);
            this.authService.company.selfServeQuickstart.cxMeetingAt = meetingDate;
            await this.authService.company.selfServeQuickstart.save();
            this.meetingDate.emit(meetingDate);
            this.analyticService.trackEvent(AnalyticEvents.SelfServeBookYourCallClickBook);
        } catch (e) {
            Sentry.captureException(e);
        }
    }
}
